import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import axios from "src/app/Service/axios";
import { NotificationService } from "src/app/Service/notification.service";
import { OtherService } from "src/app/Service/other.service";
import TileLayer from 'ol/layer/Tile';
import { MapService } from 'src/app/Service/map.service';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import {
  DragRotateAndZoom,
  defaults as defaultInteractions, Draw
} from 'ol/interaction';
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Polygon } from "ol/geom";
import Feature from "ol/Feature";
import { Fill, Stroke, Style } from "ol/style";
import BingMaps from "ol/source/BingMaps";
import { defaults as defaultControls, FullScreen } from 'ol/control';
import { DeviceDetectorService } from "ngx-device-detector";
import { GurdServiceService } from "src/app/Service/gurd-service.service";
import { XYZ } from "ol/source";
declare let $: any;

@Component({

  selector: 'busLine',

  templateUrl: './busLine.component.html',

})

export class BusLineComponent implements OnInit {

  lineData: any = [];

  txt: string = "";

  txtAddLine: string = "";

  map: any;

  isDesktop: any;

  iBusLine: any;

  fullLineData: any = [];

  stationData: any = [];

  fullStationData: any = [];

  busStationData: any = [];

  lineStationData: any = [];

  assignBusList: any = [];

  fullAssignBusList: any = [];

  GeoFenceData: any;

  editeLineData: any;

  mapSatelait: boolean = false;

  editeStationData: any;

  GeoFenceId: number = -1;

  filterAddTh: boolean = false;

  ismapCreate: boolean = false;

  source: any;

  vector: any;

  layers: any = [];

  cityCode: any;

  draw: any;

  isediteMod: boolean = false;

  bTaxi_Line: boolean = false;

  cityData: any;

  polygonEvent: any;

  fullLineStationData: any;

  vectorLayer: any;

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  saveLineForm: FormGroup = this.formBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strBusLineName: new FormControl('', Validators.required),

    strBusLineCode: new FormControl('', Validators.required),

    strColor: new FormControl(),

    strCity: new FormControl(),

    iFee: new FormControl('', Validators.required),

    fMinLength: new FormControl('', Validators.required),

  });

  saveStationForm: FormGroup = this.formBuilder.group({
    strBusStopName: new FormControl(),
    strBusStopCode: new FormControl(),
    strComment: new FormControl(""),
    strCity: new FormControl(""),
    bFake: new FormControl(false),
    // iGeoFence: new FormControl(),
    lstPoints: new FormControl(""),
    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),
  });

  mdl_Corridor: FormGroup = this.formBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iBusLine: new FormControl(""),

    lstPoints: new FormControl(""),

  });

  AddStationToLineForm: FormGroup = this.formBuilder.group({
    iBusStop: new FormControl(),
    iBusLine: new FormControl(),
    iIndex: new FormControl(),
    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),
  });

  constructor(
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private mapService: MapService,
    private deviceService: DeviceDetectorService,
    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    this.isDesktop = this.deviceService.isDesktop();

    var data = window.localStorage.getItem("cityCode") as any;

    this.cityCode = JSON.parse(this.gurdService.decrypt(data));

    this.route.url.subscribe((segment) => {

      if (segment[0].path == "taxi-line") {

        this.bTaxi_Line = true;

      }

    })

    setTimeout(() => {

      if (this.cityCode.cityName && this.cityCode.cityCode) {

        $(".autocomplete-container input")[0].value = `${this.cityCode.cityName}`;

        $(".autocomplete-container input")[1].value = `${this.cityCode.cityName}`;

        $(".autocomplete-container input")[2].value = `${this.cityCode.cityName}`;

        $(".autocomplete-container input")[3].value = `${this.cityCode.cityName}`;

        this.isediteMod = true;

        this.selectCity({ strCity: this.cityCode.cityCode });

        this.selectCityStationAdd({ strCity: this.cityCode.cityCode });

        this.selectCityStation({ strCity: this.cityCode.cityCode });

        this.selectCityLineAdd({ strCity: this.cityCode.cityCode });

        this.saveStationForm.controls["strCity"].setValue(this.cityCode.cityCode);

      }

    }, 1000);


    $('#Add-line-modal').on('hide.bs.modal', () => {
      this.saveLineForm.controls["strBusLineName"].setValue("");
      this.saveLineForm.controls["strBusLineCode"].setValue("");
      if (!this.cityCode) {

        this.saveLineForm.controls["strCity"].setValue("");
        $(".autocomplete-container input")[2].value = "";
        this.isediteMod = false;
      }
      this.editeLineData = null;
    });

    $('#line-station-modal').on('hidden.bs.modal', () => {
      this.AddStationToLineForm.controls["iIndex"].setValue("");
      this.AddStationToLineForm.controls["iBusStop"].setValue("");
      this.AddStationToLineForm.controls["iBusLine"].setValue("");
      if (!this.cityCode) {

        this.stationData = null;
        $(".autocomplete-container input")[4].value = "";

      }
    });

    $('#Add-station-modal').on('hide.bs.modal', () => {
      this.saveStationForm.controls["strBusStopName"].setValue("");
      this.saveStationForm.controls["strBusStopCode"].setValue("");
      this.saveStationForm.controls["strComment"].setValue("");
      this.saveStationForm.controls["lstPoints"].setValue("");
      this.saveStationForm.controls["bFake"].setValue(false);
      this.mapService.removeLayerByName('polygon', this.map);
      // this.saveStationForm.controls["iGeoFence"].setValue("");
      if (!this.cityCode) {
        $(".autocomplete-container input")[3].value = "";
        this.isediteMod = false;
      }
      this.editeStationData = null;
    });

    this.getArea();

    this.getCity();

  }

  getArea = async () => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      tiType: this.bTaxi_Line ? 1 : 0

    };
    this.otherService.Showspinner();
    const resp = await axios.post(`Radyab_GeoFence`, model);
    this.otherService.nonespinner();

    let respJson = JSON.parse(resp.data);
    this.GeoFenceData = respJson;
  };

  tbaIndex(id: any) {
    $(`#line`).removeClass("border-bottom border-danger");
    $(`#station`).removeClass("border-bottom border-danger");

    $(`#${id}`).addClass("border-bottom border-danger");
    if (id == "line") {
      $(`#line-div`).removeClass("d-none");
      $(`#station-div`).addClass("d-none");
    }

    if (id == "station") {
      $(`#line-div`).addClass("d-none");
      $(`#station-div`).removeClass("d-none");


    }

  }

  getLine = async (strCity?: any) => {

    if (this.lineData.length == 0 || strCity) {

      strCity = strCity ? strCity : "";

      var model = {

        ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

        strCity: strCity,

        tiType: this.bTaxi_Line ? 1 : 0

      };

      this.otherService.Showspinner();
      const resp = await axios.post(
        `Bus_ListBusLine`,
        model
      );
      this.otherService.nonespinner();
      this.lineData = JSON.parse(resp.data);
      this.fullLineData = JSON.parse(resp.data);
    }

  }

  getStation = async (strCity?: any, iBusLine?: any) => {
    strCity = strCity ? strCity : "";
    iBusLine = iBusLine ? iBusLine : "";

    var model = {
      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iBusLine: iBusLine,
      strCity: strCity,
      tiType: this.bTaxi_Line ? 1 : 0

    };
    this.otherService.Showspinner();
    const resp = await axios.post(
      `Bus_ListBusStop`,
      model
    );
    this.otherService.nonespinner();
    this.stationData = JSON.parse(resp.data);
    this.fullStationData = JSON.parse(resp.data);
    this.fullStationData.forEach((el: any) => {
      el.search = el.strBusStopName + el.strBusStopCode;
    });

  }

  clearLine() {
    this.fullLineData = [];
    this.lineData = [];
  }

  clearStation() {
    this.fullStationData = [];
    this.stationData = [];
  }

  getCity = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      tiType: this.bTaxi_Line ? 1 : 0

    };
    const resp = await axios.post(
      `Bus_GetAllCity`,
      model
    );
    this.cityData = JSON.parse(resp.data);
  }

  getLineStation = async (id: any) => {
    var model = {
      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iBusLine: id,
      tiType: this.bTaxi_Line ? 1 : 0

    };
    this.AddStationToLineForm.controls["iBusLine"].setValue(id);
    this.otherService.Showspinner();
    const resp = await axios.post(
      `Bus_ListBusLineStation`,
      model
    );
    this.otherService.nonespinner();
    this.lineStationData = JSON.parse(resp.data);
    this.fullLineStationData = JSON.parse(resp.data);
    this.getStation("", id);

  }

  getBusStation = async (id: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iBusLine: id,
      tiType: this.bTaxi_Line ? 1 : 0

    };
    this.iBusLine = id;
    this.otherService.Showspinner();
    const resp = await axios.post(
      `Bus_GetBuss`,
      model
    );
    this.otherService.nonespinner();
    this.assignBusList = JSON.parse(resp.data);
    this.fullAssignBusList = JSON.parse(resp.data);
  }

  sortLineName() {
    this.lineData.sort((a: any, b: any) => {
      var textA = a.strBusLineName.toUpperCase();
      var textB = b.strBusLineName.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }

  sortBusStopName() {
    this.stationData.sort((a: any, b: any) => {
      var textA = a.strBusStopName.toUpperCase();
      var textB = b.strBusStopName.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }

  sortLineCode() {
    this.lineData.sort((a: any, b: any) => {

      return a.strBusLineCode - b.strBusLineCode;
    });
  }

  strBusStopCode() {
    this.stationData.sort((a: any, b: any) => {

      return a.strBusStopCode - b.strBusStopCode;
    });
  }

  strBusStopFake() {
    this.stationData.sort((a: any, b: any) => {

      return a.bFake - b.bFake;
    });
  }

  filterLine(val: any) {
    this.lineData = this.fullLineData.filter((el: any) => {
      return el.strBusLineName.includes(val.value);
    });
    if (this.lineData.length == 0) {
      this.lineData = this.fullLineData.filter((el: any) => {
        return el.strBusLineCode.includes(val.value);
      });
    }
  }

  filterStation(val: any) {
    this.stationData = this.fullStationData.filter((el: any) => {
      return el.strBusStopName.includes(val.value);
    });
    if (this.stationData.length == 0) {
      this.stationData = this.fullStationData.filter((el: any) => {
        return el.strBusStopCode.includes(val.value);
      });
    }
  }

  deleteLine(id: any) {
    $.confirm({
      title: `آیا از حذف این خط اطمینان دارید ؟`,
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: "حذف",
          btnClass: 'btn-success',
          keys: ['enter'],
          action: async () => {
            var model = {
              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
              iBusLine: id,
              tiType: this.bTaxi_Line ? 1 : 0

            };
            const resp = await axios.post(`Bus_DeleteBusLine`, model);


            let resParse = JSON.parse(resp.data);
            if (resParse.iResult == 0) {
              this.notifyService.showError(resParse.strError);
              return;
            }
            if (resParse.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');
              this.otherService.removeLocalStorage();
              // this.router.navigate(['login']);
              this.router.navigate(['login'], { queryParams: { error: '1' } });

              return;
            }
            else {
              this.notifyService.showSuccess("با موفقیت حذف شد");
              this.fullLineData = this.fullLineData.filter((el: any) => {
                return el.iBusLine != id;
              });
              this.lineData = this.lineData.filter((el: any) => {
                return el.iBusLine != id;
              });
            }
            return;

          }
        },
        cancel: {
          text: "لغو",

        }
      }
    });
  }

  deleteStation(id: any) {
    $.confirm({
      title: `آیا از حذف این ایستگاه اطمینان دارید ؟`,
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: "حذف",
          btnClass: 'btn-success',
          keys: ['enter'],
          action: async () => {
            var model = {
              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
              iBusStop: id,
              tiType: this.bTaxi_Line ? 1 : 0

            };
            const resp = await axios.post(`Bus_DeleteBusStop`, model);
            let resParse = JSON.parse(resp.data);
            if (resParse.iResult == 0) {
              this.notifyService.showError(resParse.strError);
              return;
            }
            if (resParse.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');
              this.otherService.removeLocalStorage();
              // this.router.navigate(['login']);
              this.router.navigate(['login'], { queryParams: { error: '2' } });

              return;
            }
            else {
              this.notifyService.showSuccess("با موفقیت حذف شد");
              this.fullStationData = this.fullStationData.filter((el: any) => {
                return el.iBusStop != id;
              });
              this.stationData = this.stationData.filter((el: any) => {
                return el.iBusStop != id;
              });
            }
            return;

          }
        },
        cancel: {
          text: "لغو",

        }
      }
    });
  }

  saveLine = async () => {

    var model = this.saveLineForm.value;

    model.tiType = this.bTaxi_Line ? 1 : 0;

    if (this.saveLineForm.invalid) {

      this.notifyService.showError("موارد ستاره دار را وارد کنید");

      return;

    }

    if (!model.strBusLineName) {

      this.notifyService.showError("لطفا نام خط را وارد کنید");

      return;

    }

    if (!model.strBusLineCode) {

      this.notifyService.showError("لطفا کد خط را وارد کنید");

      return;

    }

    const resp = await axios.post(`Bus_AddBusLine`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {

      this.notifyService.showError(resParse.strError);

      return;

    }

    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: '3' } });

      return;
    }

    else {
      this.notifyService.showSuccess("با موفقیت ثبت شد");
      this.fullLineData.push(resParse);
      this.lineData.push(resParse);
      $("#Add-line-modal").modal("hide");
    }

    return;
  }

  saveStation = async () => {
    var model = this.saveStationForm.value;
    model.tiType = this.bTaxi_Line ? 1 : 0;

    if (!model.strBusStopName) {
      this.notifyService.showError("لطفا نام ایستگاه را وارد کنید");
      return;
    }
    if (!model.strBusStopCode) {
      this.notifyService.showError("لطفا کد ایستگاه را وارد کنید");
      return;
    }
    if (!model.lstPoints) {
      this.notifyService.showError("لطفا  منطقه را ترسیم  کنید");
      return;
    }
    const resp = await axios.post(
      `Bus_AddBusStop`,
      model
    );
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;
    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '4' } });

      return;
    }
    else {
      this.notifyService.showSuccess("با موفقیت ثبت شد");
      this.fullStationData.push(resParse);
      this.stationData.push(resParse);
      this.fullStationData.forEach((el: any) => {
        el.search = el.strBusStopName + el.strBusStopCode;
      });
      $("#Add-station-modal").modal("hide");
    }
    return;
  }

  editeLineModal = async (item: any, index: any) => {
    this.saveLineForm.controls["strBusLineName"].setValue(item.strBusLineName);
    this.saveLineForm.controls["strBusLineCode"].setValue(item.strBusLineCode);
    this.saveLineForm.controls["strColor"].setValue(item.strColor);
    this.saveLineForm.controls["strCity"].setValue(item.strCity);
    if (this.cityData) {
      this.isediteMod = true;
    }
    $(".autocomplete-container input")[2].value = item.strCityName;
    this.txtAddLine = item.strCityName;
    this.editeLineData = item;
    this.editeLineData.index = index;
  }

  editeStationModal = async (item: any, index: any) => {
    this.newOpenMap();
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      iBusStop: item.iBusStop,
      tiType: this.bTaxi_Line ? 1 : 0

    };
    const resp = await axios.post(`Bus_BusStopInfo`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;
    }
    this.saveStationForm.controls["strBusStopName"].setValue(resParse.strBusStopName);
    $(".autocomplete-container input")[3].value = resParse.strCityName;
    this.isediteMod = true;
    this.saveStationForm.controls["strBusStopCode"].setValue(resParse.strBusStopCode);
    this.saveStationForm.controls["bFake"].setValue(resParse.bFake);
    this.saveStationForm.controls["strComment"].setValue(resParse.strComment);
    this.saveStationForm.controls["strCity"].setValue(resParse.strCity);

    setTimeout(() => {

      var ring = [];
      if (resParse.lstPoints.length != 0) {
        var loc = resParse.lstPoints;
        for (let index = 0; index < loc.length; index++) {
          ring.push([loc[index].fLon, loc[index].fLat]);
        }
        var polygon = new Polygon([ring]);
        polygon.transform('EPSG:4326', 'EPSG:3857');
        var feature = new Feature(polygon);
        var vectorSource = new VectorSource();
        vectorSource.addFeature(feature);
        var vectorLayer = new VectorLayer({
          source: vectorSource,
          name: 'polygon',
          style: new Style({
            stroke: new Stroke({
              color: 'red',
              width: 4,
              lineDash: [10, 20, 10, 20]
            }),
            fill: new Fill({
              color: 'rgba(0, 0, 255, 0)'
            })
          }),
        } as any);
        this.map.addLayer(vectorLayer);
        this.mapService.fitMap(resParse.lstPoints, this.map);
        this.map.getView().setZoom(17);

      }
    }, 500);

    this.editeStationData = item;
    this.editeStationData.index = index;
  }

  editeLine = async () => {

    var model = this.saveLineForm.value;

    model.iBusLine = this.editeLineData.iBusLine;

    model.tiType = this.bTaxi_Line ? 1 : 0

    if (this.saveLineForm.invalid) {

      this.notifyService.showError("موارد ستاره دار را وارد کنید");

      return;

    }

    if (!model.strBusLineName) {

      this.notifyService.showError("لطفا نام خط را وارد کنید");

      return;

    }

    if (!model.strBusLineCode) {

      this.notifyService.showError("لطفا کد خط را وارد کنید");

      return;

    }

    const resp = await axios.post(`Bus_EditBusLine`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;
    }

    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '5' } });

      return;
    }

    else {
      this.notifyService.showSuccess("با موفقیت ثبت شد");
      this.lineData[this.editeLineData.index] = resParse;
      $("#Add-line-modal").modal("hide");
    }

    return;
  }

  editeStation = async () => {
    var model = this.saveStationForm.value;
    model.iBusStop = this.editeStationData.iBusStop;
    model.tiType = this.bTaxi_Line ? 1 : 0

    if (!model.strBusStopName) {
      this.notifyService.showError("لطفا نام ایستگاه را وارد کنید");
      return;
    }
    if (!model.strBusStopCode) {
      this.notifyService.showError("لطفا کد ایستگاه را وارد کنید");
      return;
    }
    // if (!model.lstPoints) {
    //   this.notifyService.showError("لطفا محدوده ایستگاه  را ترسیم کنید");
    //   return;
    // }

    const resp = await axios.post(
      `Bus_EditBusStop`,
      model
    );
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;
    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '6' } });

      return;
    }
    else {
      this.notifyService.showSuccess("با موفقیت ثبت شد");
      this.stationData[this.editeStationData.index] = resParse;
      $("#Add-station-modal").modal("hide");
    }
    return;
  }

  keyword = 'search';

  keywordCity = 'strCityName';

  selectEvent(item: any) {
    this.AddStationToLineForm.controls["iBusStop"].setValue(item.iBusStop);
  }

  selectCityStationAdd(item: any) {

    this.saveStationForm.controls["strCity"].setValue(item.strCity);
  }

  selectCityLineAdd(item: any) {
    this.saveLineForm.controls["strCity"].setValue(item.strCity);
  }

  selectCity(item: any) {
    this.getLine(item.strCity);
  }

  selectCityStation(item: any) {
    this.getStation(item.strCity);
  }

  addStationToLine = async () => {
    var model = this.AddStationToLineForm.value;
    model.tiType = this.bTaxi_Line ? 1 : 0

    if (!model.iIndex) {
      this.notifyService.showError("لطفا شماره ردیف را وارد کنید");
      return;
    }
    if (!model.iBusStop) {
      this.notifyService.showError("لطفا نام ایستگاه را وارد کنید");
      return;
    }
    const resp = await axios.post(
      `Bus_AddBusLineStation`,
      model
    );
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;
    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '7' } });
      return;
    }
    else {
      this.notifyService.showSuccess("با موفقیت ثبت شد");
      this.AddStationToLineForm.controls["iIndex"].setValue("");
      this.AddStationToLineForm.controls["iBusStop"].setValue("");
      this.AddStationToLineForm.controls["iBusStop"].setValue("");
      this.lineStationData.push(resParse);
      this.fullLineStationData.push(resParse);
      $(".autocomplete-container input")[0].value = "";

    }
  }

  deleteStationFromLine = async (iBusLine: any, iBusStop: any) => {
    $.confirm({
      title: `آیا از حذف این ایستگاه اطمینان دارید ؟`,
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: "حذف",
          btnClass: 'btn-success',
          keys: ['enter'],
          action: async () => {
            var model = {
              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
              iBusLine: iBusLine,
              iBusStop: iBusStop,
              tiType: this.bTaxi_Line ? 1 : 0


            };
            const resp = await axios.post(`Bus_DeleteBusLineStation`, model);


            let resParse = JSON.parse(resp.data);
            if (resParse.iResult == 0) {
              this.notifyService.showError(resParse.strError);
              return;
            }
            if (resParse.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');
              this.otherService.removeLocalStorage();
              // this.router.navigate(['login']);
              this.router.navigate(['login'], { queryParams: { error: '8' } });

              return;
            }
            else {
              this.notifyService.showSuccess("با موفقیت حذف شد");
              this.lineStationData = this.fullLineStationData.filter((el: any) => {
                return el.iBusStop != iBusStop;
              });

            }
            return;

          }
        },
        cancel: {
          text: "لغو",

        }
      }
    });
  }

  filterBus(val: any) {
    this.assignBusList = this.fullAssignBusList.filter((el: any) => {
      return el.strFullName.includes(val.value);
    });
    if (this.assignBusList.length == 0) {
      this.assignBusList = this.fullAssignBusList.filter((el: any) => {
        return el.strUnitID.includes(val.value);
      });

    }
    if (this.assignBusList.length == 0) {
      this.assignBusList = this.fullAssignBusList.filter((el: any) => {
        return el.strSystemUser_strMobile.includes(val.value);
      });

    }

    if (this.assignBusList.length == 0) {
      this.assignBusList = this.fullAssignBusList.filter((el: any) => {
        return el.strMobileDomain_strComment.includes(val.value);
      });


    }


  }

  filterAdd() {
    this.filterAddTh = !this.filterAddTh;
    if (this.filterAddTh) {
      this.assignBusList = this.fullAssignBusList.filter((el: any) => {
        return el.bHas != 0;
      });

    }
    else {
      this.assignBusList = this.fullAssignBusList;
    }

  }

  addOrRemoveCar = async (id: any) => {
    var model = {
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      iBusLine: this.iBusLine,
      strUnitID: id,
      tiType: this.bTaxi_Line ? 1 : 0

    }
    const resp = await axios.post(`Bus_AddOrRemoveMobileFromBusLine`, model);
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
      return;

    }
    if (resp.data.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '9' } });

      return;
    }
    else {
      // this.notifyService.showSuccess(resp.data.strError);

    }

  }

  newOpenMap() {

    setTimeout(() => {

      if (!this.ismapCreate) {

        this.source = new VectorSource({ wrapX: false });

        this.vector = new VectorLayer({
          source: this.source,
        });

        if (this.bOfflineMap) {

          this.layers.push(

            new TileLayer({

              source: new XYZ({

                // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

                url: this.strMapUrl,

                attributions: 'Map data © RayanAndishehNasr' // 

              }),

            })

          );

        }

        else {

          const styles = [

            'AerialWithLabelsOnDemand',

          ];

          let i, ii;

          for (i = 0, ii = styles.length; i < ii; ++i) {

            this.layers.push(
              new TileLayer({
                visible: false,
                preload: Infinity,
                source: new BingMaps({
                  // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                  key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                  imagerySet: styles[i],
                }),

              }),

            );

          }

          this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector);


        }

        this.map = new Map({

          layers: this.layers,

          target: 'test',

          view: new View({
            center: olProj.fromLonLat([51.3833554, 35.6770113]),
            zoom: 13,
          }),

        });

        this.ismapCreate = true;

      }

    }, 500);

    setTimeout(() => {
      //Handel Add Polygon
      this.vector.getSource().on('addfeature', (e: any) => {
        this.polygonEvent = e.feature;
        this.source.removeFeature(e.feature);
        this.source.removeFeature(this.polygonEvent);
        this.savePolygon();
      });
      //let draw: any;
      const value = 'Polygon';
      //if (value !== 'None') {
      this.draw = new Draw({
        source: this.source,
        type: value,
      });
      this.map.addInteraction(this.draw);
      //}
    }, 700);

    //context menu
  }

  savePolygon = async () => {

    var point = [] as any;

    this.draw.sketchLineCoords_.forEach((item: any, index: any) => {

      var data = this.mapService.transformCoordinates(item);

      point.push({ fLat: data[1], fLon: data[0] });

    });

    this.notifyService.showSuccess("محدوده با موفقیت ترسیم شد.");

    this.saveStationForm.controls["lstPoints"].setValue(point);

    this.mdl_Corridor.controls["lstPoints"].setValue(point);

    this.showPolygon(point);


  }

  changeTail() {

    if (this.mapSatelait == false) {
      this.layers[1].setVisible(false);

      this.layers[0].setVisible(true);
    }
    else {
      this.layers[0].setVisible(false);

      this.layers[1].setVisible(true);
    }
    this.mapSatelait = !this.mapSatelait;

  }

  search(val: any) {
    this.lineStationData = this.fullLineStationData.filter((el: any) => {
      return el.strBusLineName.includes(val.value);
    });
    if (this.lineStationData.length == 0) {
      this.lineStationData = this.fullLineStationData.filter((el: any) => {
        return el.strBusStopCode.includes(val.value);
      });

    }
  }

  openCorridor(item, index) {

    this.mdl_Corridor.patchValue({

      iBusLine: item.iBusLine,

      lstPoints: item.lstPoints || []

    })

    $("#Add-Corridor-modal").modal('show');

    setTimeout(() => {

      this.showPolygon(item.lstPoints || [])

    }, 800);

    setTimeout(() => {

      if (!this.ismapCreate) {

        this.source = new VectorSource({ wrapX: false });

        this.vector = new VectorLayer({

          source: this.source,

        });


        if (this.bOfflineMap) {

          this.layers.push(

            new TileLayer({

              source: new XYZ({

                // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

                url: this.strMapUrl,

                attributions: 'Map data © RayanAndishehNasr' // 

              }),

            })

          );

        }

        else {

          const styles = [

            'AerialWithLabelsOnDemand',

          ];

          let i, ii;

          for (i = 0, ii = styles.length; i < ii; ++i) {

            this.layers.push(

              new TileLayer({

                visible: false,

                preload: Infinity,

                source: new BingMaps({

                  // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                  key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',


                  imagerySet: styles[i],

                }),

              }),

            );
          }

          this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


        }

        this.map = new Map({

          layers: this.layers,

          target: 'corridor',

          view: new View({

            center: olProj.fromLonLat([51.3833554, 35.6770113]),

            zoom: 13,

          }),

        });

        this.ismapCreate = true;
      }

    }, 500);

    setTimeout(() => {

      this.vector.getSource().on('addfeature', (e: any) => {

        this.polygonEvent = e.feature;

        this.source.removeFeature(e.feature);

        this.source.removeFeature(this.polygonEvent);

        this.savePolygon();

      });

      const value = 'Polygon';

      this.draw = new Draw({

        source: this.source,

        type: value,

      });

      this.map.addInteraction(this.draw);

    }, 700);

  }

  showPolygon(point: any[],) {

    if (this.mdl_Corridor.get('lstPoints')?.value != '') {

      this.mapService.removeLayerByName('polygon', this.map);

    }

    // Remove the previous polygon

    if (this.vectorLayer) this.map.removeLayer(this.vectorLayer);

    if (point.length != 0) {

      var ring = [];

      for (let index = 0; index < point.length; index++) {

        ring.push([point[index].fLon, point[index].fLat]);

      }

      var polygon = new Polygon([ring]);

      polygon.transform('EPSG:4326', 'EPSG:3857');

      var feature = new Feature(polygon);

      var vectorSource = new VectorSource();

      vectorSource.addFeature(feature);

      var vectorLayer = new VectorLayer({

        source: vectorSource,

        name: 'polygon',

        style: new Style({

          stroke: new Stroke({

            color: 'red',

            width: 4,

            lineDash: [10, 20, 10, 20]

          }),

          fill: new Fill({

            color: 'rgba(0, 0, 255, 0)'

          })

        }),

      } as any);


      this.vectorLayer = vectorLayer;

      this.map.addLayer(vectorLayer);

      this.fitToAll(point);


    }

  }

  fitToAll(obj: any[]) {

    let maxLatitude = -Infinity;

    let maxLongitude = -Infinity;

    let minLatitude = Infinity;

    let minLongitude = Infinity;

    for (const item of obj) {

      if (item.fLat > maxLatitude) maxLatitude = item.fLat;

      if (item.fLon > maxLongitude) maxLongitude = item.fLon;

      if (item.fLat < minLatitude) minLatitude = item.fLat;

      if (item.fLon < minLongitude) minLongitude = item.fLon;
    }

    var model: any = {

      maxLatitude: maxLatitude,

      maxLongitude: maxLongitude,

      minLatitude: minLatitude,

      minLongitude: minLongitude

    }

    var view = this.map.getView();

    var transformedStart = this.mapService.transformCoordinates2([

      model.maxLongitude,

      model.maxLatitude,

    ]);

    var transformedEnd = this.mapService.transformCoordinates2([

      model.minLongitude,

      model.minLatitude,

    ]);

    var source = [
      Math.min(transformedStart[0], transformedEnd[0]) - 300,
      Math.min(transformedStart[1], transformedEnd[1]) - 300,
      Math.max(transformedStart[0], transformedEnd[0]) + 300,
      Math.max(transformedStart[1], transformedEnd[1]) + 300,
    ];

    view.fit(source);
  }

  editCorridor = async () => {

    let model = this.mdl_Corridor.value;

    model.tiType = this.bTaxi_Line ? 1 : 0;

    this.otherService.Showspinner();

    const resp = await axios.post(`Bus_BusLine_Corridor`, this.otherService.stringNumberToNumber(model));

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data.toString())

    if (res.iResult == 0) {

      this.notifyService.showError(res.strError);

      return;

    }

    if (res.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();


      this.router.navigate(['login'], { queryParams: { error: '9s' } });

      return;

    }

    this.notifyService.showSuccess('با موفقیت ثبت شد');

    $("#Add-Corridor-modal").modal('hide');


  }

}
